var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.732 8.25L0.757 2.275C0.522549 2.04055 0.390835 1.72256 0.390835 1.391C0.390835 1.05944 0.522549 0.741451 0.757 0.506999C0.991451 0.272548 1.30944 0.140834 1.641 0.140834C1.97256 0.140834 2.29055 0.272548 2.525 0.506999L9.243 7.225C9.523 7.505 9.643 7.885 9.601 8.25C9.62239 8.43678 9.6013 8.62598 9.5393 8.80347C9.47731 8.98096 9.37602 9.14215 9.243 9.275L2.525 15.993C2.40891 16.1091 2.27109 16.2012 2.11942 16.264C1.96774 16.3268 1.80517 16.3592 1.641 16.3592C1.47683 16.3592 1.31426 16.3268 1.16258 16.264C1.01091 16.2012 0.873089 16.1091 0.757 15.993C0.640911 15.8769 0.548825 15.7391 0.485998 15.5874C0.423171 15.4357 0.390835 15.2732 0.390835 15.109C0.390835 14.9448 0.423171 14.7823 0.485998 14.6306C0.548825 14.4789 0.640911 14.3411 0.757 14.225L6.732 8.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 17,
    fill: "white",
    transform: "translate(10 17) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnNext);
export default __webpack_public_path__ + "static/media/btnNext.05473598.svg";
export { ForwardRef as ReactComponent };